import { useSelector } from "react-redux";
import { homeStateSelector } from "@store/redux/modules/home";
import { speakText } from "../Hour";
import { useTranslation } from "react-i18next";
const CurrentWeather: React.FC = () => {
  const { current = {} } = useSelector(homeStateSelector);
  const { t: $t } = useTranslation();
  const handleSpeakClick = () => {
    const temperature = current?.Temperature?.Value ? `${current.Temperature.Value} degrees Celsius` : "";
    const weatherText = current?.WeatherText ? `Weather: ${current.WeatherText}` : "";
    const realFeelTemperature = current?.RealFeelTemperature?.Value
      ? `Real Feel Temperature: ${current.RealFeelTemperature.Value} degrees Celsius`
      : "";
    const realFeelTemperatureShade = current?.RealFeelTemperatureShade?.Value
      ? `Real Feel Temperature Shade: ${current.RealFeelTemperatureShade.Value} degrees Celsius`
      : "";
    const past24HourRange =
      current?.Past24HourRange?.Maximum?.Value && current?.Past24HourRange?.Minimum?.Value
        ? `Temperature Range: ${current.Past24HourRange.Minimum.Value} to ${current.Past24HourRange.Maximum.Value} degrees Celsius`
        : "";

    const text = [
      $t("title01"),
      current?.SpecialDate,
      weatherText,
      temperature,
      past24HourRange,
      realFeelTemperature,
      realFeelTemperatureShade,
    ]
      .filter(Boolean)
      .join(". ");

    speakText(text);
  };

  return (
    <>
      <WeatherMainContent className="content flex flex-col gap-y-16" onClick={handleSpeakClick}>
        <div className="w-full flex justify-between items-center">
          <div className="text-16 font-400">{$t("title01")}</div>
          {!isEmptyType(current?.SpecialDate) && <div className="text-12 font-300">{current.SpecialDate}</div>}
        </div>
        <div className="flex items-center gap-x-40 w-full">
          <div className="w-126 overflow-hidden flex flex-col items-center gap-y-8">
            <p className="h-100 relative text-center">
              <WeatherImage className="w-90" src={current?.WeatherIconImg} />
            </p>
            {!isEmptyType(current?.WeatherText) && <p className="w-full pl-15 text-18">{current.WeatherText}</p>}
          </div>
          <div className="flex flex-col items-center justify-start gap-y-8">
            {!isEmptyType(current?.Temperature?.Value) && (
              <p className="h-100 relative flex" dir="auto">
                <span className="text-80">{current.Temperature.Value}</span>{" "}
                <span className="text-30 align-top lh-70 font-400">℃</span>
              </p>
            )}
            {!isEmptyType(current?.Past24HourRange?.Maximum?.Value || current?.Past24HourRange?.Minimum?.Value) && (
              <p className="w-full pl-15 text-18">
                {current.Past24HourRange.Maximum.Value +
                  current.Past24HourRange.Maximum.Unit +
                  "/" +
                  current.Past24HourRange.Minimum.Value +
                  current.Past24HourRange.Minimum.Unit}
              </p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-x-8 text-12">
          {!isEmptyType(current?.RealFeelTemperature?.Value) && (
            <>
              <p className="lh-22">
                {$t("title21")} {current.RealFeelTemperature.Value}
                {current?.RealFeelTemperature?.Unit}
              </p>
              <p className="lh-22">|</p>
            </>
          )}
          {!isEmptyType(current?.RealFeelTemperatureShade?.Value) && (
            <p className="lh-22">
              {$t("title22")} {current.RealFeelTemperatureShade.Value}
              {current?.RealFeelTemperatureShade?.Unit}
            </p>
          )}
        </div>
      </WeatherMainContent>
    </>
  );
};
export default CurrentWeather;
